import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CommonService } from '../../services/common.service';
import { User, UserAPI } from '../user';
import {
  AerosolOrdonnanceInformationsForm,
  AerosolOrdonnanceInformationsFormAPI,
} from './aerosolOrdonnanceInformationsForm';
import {
  AvfOrdonnanceInformationsForm,
  AvfOrdonnanceInformationsFormAPI,
} from './avfOrdonnanceInformationsForm';
import {
  DepInformationsComplementaires,
  DepInformationsComplementairesAPI,
} from './depInformationsComplementaires';
import {
  DepInformationsForm,
  DepInformationsFormAPI,
} from './depInformationsForm';
import {
  PpcDapInformationsForm,
  PpcDapInformationsFormAPI,
} from './ppcDapInformationsForm';
import {
  PpcInformationsComplementaires,
  PpcInformationsComplementairesAPI,
} from './ppcInformationsComplementaires';
import { PpcOrdoclicInformationsForm } from './ppcOrdoclicInformationsForm';
import {
  PpcOrdonnanceInformationsForm,
  PpcOrdonnanceInformationsFormAPI,
} from './ppcOrdonnanceInformationsForm';
import {
  PrescriptionFormType,
  PrescriptionFormTypeAPI,
} from './prescriptionFormType';

export class PrescriptionForm {
  id?: number;
  typeSlug: string;
  type?: PrescriptionFormType;
  medecinId: number;
  medecin: User | undefined;
  userId: number;
  user: User | undefined;
  nir: string;
  codeDActivite: string;
  dateDePrescription: Date;
  nom: string;
  prenom: string;
  sexe?: 'homme' | 'femme';
  dateDeNaissance?: Date;
  adresseLigne1?: string;
  adresseLigne2?: string | null;
  adresseCodePostal?: string;
  adresseVille?: string;
  telephone: string;
  aSigner: boolean;
  transmise: boolean;
  pdf?: string | null;
  createdAt?: Date;
  prescription_number?: number;
  informationsComplementaires?:
    | DepInformationsComplementaires
    | PpcInformationsComplementaires;
  informationsForm?:
    | DepInformationsForm
    | PpcDapInformationsForm
    | PpcOrdonnanceInformationsForm
    | PpcOrdoclicInformationsForm
    | AvfOrdonnanceInformationsForm
    | AerosolOrdonnanceInformationsForm;

  constructor(
    id: number | undefined,
    typeSlug: string,
    type: PrescriptionFormType | undefined,
    medecinId: number,
    medecin: User | undefined,
    userId: number,
    user: User | undefined,
    nir: string,
    codeDActivite: string,
    dateDePrescription: Date,
    nom: string,
    prenom: string,
    sexe: 'homme' | 'femme' | undefined,
    dateDeNaissance: Date | undefined,
    adresseLigne1: string | undefined,
    adresseLigne2: string | null | undefined,
    adresseCodePostal: string | undefined,
    adresseVille: string | undefined,
    telephone: string,
    aSigner: boolean,
    transmise: boolean,
    pdf?: string | null,
    createdAt?: Date,
    prescription_number?: number,
    informationsComplementaires?:
      | DepInformationsComplementaires
      | PpcInformationsComplementaires,
    informationsForm?:
      | DepInformationsForm
      | PpcDapInformationsForm
      | PpcOrdonnanceInformationsForm
      | PpcOrdoclicInformationsForm
      | AvfOrdonnanceInformationsForm
      | AerosolOrdonnanceInformationsForm,
  ) {
    this.id = id;
    this.typeSlug = typeSlug;
    this.type = type;
    this.medecinId = medecinId;
    this.medecin = medecin;
    this.userId = userId;
    this.user = user;
    this.nir = nir;
    this.codeDActivite = codeDActivite;
    this.dateDePrescription = dateDePrescription;
    this.nom = nom;
    this.prenom = prenom;
    this.sexe = sexe;
    this.dateDeNaissance = dateDeNaissance;
    this.adresseLigne1 = adresseLigne1;
    this.adresseLigne2 = adresseLigne2;
    this.adresseCodePostal = adresseCodePostal;
    this.adresseVille = adresseVille;
    this.telephone = telephone;
    this.aSigner = aSigner;
    this.transmise = transmise;
    this.pdf = pdf;
    this.createdAt = createdAt;
    this.prescription_number = prescription_number;
    this.informationsComplementaires = informationsComplementaires;
    this.informationsForm = informationsForm;
  }

  static factory(basePrescriptionAPI: PrescriptionFormAPI): PrescriptionForm {
    return new PrescriptionForm(
      basePrescriptionAPI.id,
      basePrescriptionAPI.prescription_form_type_slug,
      basePrescriptionAPI.type
        ? PrescriptionFormType.factory(basePrescriptionAPI.type)
        : undefined,
      basePrescriptionAPI.medecin_id,
      basePrescriptionAPI.medecin
        ? User.factory(basePrescriptionAPI.medecin)
        : undefined,
      basePrescriptionAPI.user_id,
      basePrescriptionAPI.user
        ? User.factory(basePrescriptionAPI.user)
        : undefined,
      basePrescriptionAPI.nir,
      basePrescriptionAPI.code_d_activite,
      new Date(basePrescriptionAPI.date_de_prescription),
      basePrescriptionAPI.nom,
      basePrescriptionAPI.prenom,
      basePrescriptionAPI.sexe,
      basePrescriptionAPI.date_de_naissance
        ? new Date(basePrescriptionAPI.date_de_naissance)
        : undefined,
      basePrescriptionAPI.adresse_ligne_1,
      basePrescriptionAPI.adresse_ligne_2,
      basePrescriptionAPI.adresse_code_postal,
      basePrescriptionAPI.adresse_ville,
      basePrescriptionAPI.telephone,
      basePrescriptionAPI.a_signer,
      basePrescriptionAPI.transmise,
      basePrescriptionAPI.pdf,
      basePrescriptionAPI.created_at
        ? new Date(basePrescriptionAPI.created_at)
        : undefined,
      basePrescriptionAPI.prescription_number,
      (() => {
        switch (basePrescriptionAPI.prescription_form_type_slug) {
          case 'ppc_ordonnance':
          case 'ppc_ordoclic':
          case 'ppc_dap':
            return basePrescriptionAPI.ppc_informations_complementaires
              ? PpcInformationsComplementaires.factory(
                  basePrescriptionAPI.ppc_informations_complementaires,
                )
              : undefined;
          case 'dep':
            return basePrescriptionAPI.dep_informations_complementaires
              ? DepInformationsComplementaires.factory(
                  basePrescriptionAPI.dep_informations_complementaires,
                )
              : undefined;
          default:
            return undefined;
        }
      })(),
    );
  }

  toAPI(): PrescriptionFormAPI {
    return {
      prescription_form_type_slug: this.typeSlug,
      medecin_id: this.medecinId,
      user_id: this.userId,
      nir: this.nir,
      code_d_activite: this.codeDActivite,
      date_de_prescription: this.dateDePrescription.toISOString(),
      nom: this.nom,
      prenom: this.prenom,
      sexe: this.sexe,
      date_de_naissance: this.dateDeNaissance
        ? this.dateDeNaissance.toISOString()
        : undefined,
      adresse_ligne_1: this.adresseLigne1,
      adresse_ligne_2: this.adresseLigne2,
      adresse_code_postal: this.adresseCodePostal,
      adresse_ville: this.adresseVille,
      telephone: this.telephone,
      a_signer: this.aSigner,
      transmise: this.transmise,
      prescription_number: this.prescription_number,
      pdf: this.pdf,
      ppc_informations_complementaires:
        this.informationsComplementaires instanceof
        PpcInformationsComplementaires
          ? this.informationsComplementaires.toAPI()
          : undefined,
      dep_informations_complementaires:
        this.informationsComplementaires instanceof
        DepInformationsComplementaires
          ? this.informationsComplementaires.toAPI()
          : undefined,
      ppc_dap_informations_form:
        this.informationsForm instanceof PpcDapInformationsForm
          ? this.informationsForm.toAPI()
          : undefined,
      ppc_ordonnance_informations_form:
        this.informationsForm instanceof PpcOrdonnanceInformationsForm
          ? this.informationsForm.toAPI()
          : undefined,
      dep_informations_form:
        this.informationsForm instanceof DepInformationsForm
          ? this.informationsForm.toAPI()
          : undefined,
      avf_ordonnance_informations_form:
        this.informationsForm instanceof AvfOrdonnanceInformationsForm
          ? this.informationsForm.toAPI()
          : undefined,
      aerosol_ordonnance_informations_form:
        this.informationsForm instanceof AerosolOrdonnanceInformationsForm
          ? this.informationsForm.toAPI()
          : undefined,
    };
  }

  toOrdoclic(
    medecin: User,
  ): PrescriptionFormOrdoclicInitial | PrescriptionFormOrdoclicRenouvellement {
    if (
      this.informationsComplementaires instanceof
        PpcInformationsComplementaires &&
      this.informationsForm instanceof PpcOrdoclicInformationsForm
    ) {
      return this.informationsComplementaires.ppcTypeSlug == 'dap_initial'
        ? {
            formType: environment.ordoclic.new_dap,
            autoSubmission: true,
            inputs: {
              user_id: medecin.id,
              qualification: {
                ...(medecin.qualification?.slug == 'desFstSommeil'
                  ? { desFstSommeil: true }
                  : {}),
                ...(medecin.qualification?.slug == 'parcoursSommeilAtteste'
                  ? { parcoursSommeilAtteste: true }
                  : {}),
                ...(medecin.qualification?.slug == 'diplomePathoSommeil'
                  ? { diplomePathoSommeil: true }
                  : {}),
              },
              patient: {
                nir: this.nir.slice(0, -2),
                cle_nir: this.nir.slice(-2),
                fullname: `${this.prenom
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .toUpperCase()} ${this.nom
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .toUpperCase()}`,
                adresse: `${this.adresseLigne1} (${this.adresseLigne2})`,
                code_postal: this.adresseCodePostal ?? 'Ø',
                ville: this.adresseVille ?? 'Ø',
                telephone: this.telephone,
                date_naissance: this.dateDeNaissance
                  ? this.dateDeNaissance.toISOString().split('T')[0]
                  : 'Ø',
                nom_mutuelle: this.informationsForm.nomMutuelle,
                numero_mutuelle: this.informationsForm.numeroMutuelle,
              },
              dap: {
                ...(this.informationsComplementaires.examen_realise ==
                'polysomnographie'
                  ? {
                      polysomnographie: true,
                    }
                  : {}),
                ...(this.informationsComplementaires.examen_realise ==
                'polygraphie'
                  ? {
                      polygraphie: true,
                    }
                  : {}),
                microEveils:
                  this.informationsComplementaires.examen_realise ==
                  'polysomnographie'
                    ? parseInt(
                        this.informationsComplementaires.microEveils?.toString() ??
                          '',
                      )
                    : undefined,
                ...(this.informationsComplementaires.iahGap == 'lt15'
                  ? { iahLt15: true }
                  : this.informationsComplementaires.iahGap == 'gt15_lt30'
                    ? { iahGt15Lt30: true }
                    : { iahGt30: true }),
                compteRendu: {
                  fileName: 'compte_rendu.pdf',
                  mimeType: 'application/pdf',
                  content: this.informationsComplementaires.compteRendu ?? null,
                },
                ...(this.informationsComplementaires.somnolenceDiurne
                  ? { somnolenceDiurne: true }
                  : {}),
                ...(this.informationsComplementaires.ronflementsSeveres
                  ? { ronflementsSeveres: true }
                  : {}),
                ...(this.informationsComplementaires.cephaleesMatinales
                  ? { cephaleesMatinales: true }
                  : {}),
                ...(this.informationsComplementaires.fatigueDiurne
                  ? { fatigueDiurne: true }
                  : {}),
                ...(this.informationsComplementaires.nycturie
                  ? { nycturie: true }
                  : {}),
                ...(this.informationsComplementaires.sensationEtouffement
                  ? { sensationEtouffement: true }
                  : {}),
                ...(this.informationsComplementaires
                  .somnolenceDiurneSevereRisqueAccidentel
                  ? { somnolenceDiurneSevereRisqueAccidentel: true }
                  : {}),
                ...(this.informationsComplementaires
                  .comorbiditeCardioVasculaireGrave
                  ? { comorbiditeCardioVasculaireGrave: true }
                  : {}),
                ...(this.informationsComplementaires
                  .comorbiditeRespiratoireGrave
                  ? { comorbiditeRespiratoireGrave: true }
                  : {}),
                oam12DerniersMoisNon: true,
                orientationVersOamCommentaire:
                  this.informationsForm.commentaire,
              },
              prescription: {
                ...(this.informationsForm.ald
                  ? { aldOui: true }
                  : { aldNon: true }),
                typeAppareil: (() => {
                  switch (this.informationsForm.typeAppareil) {
                    case 'a_pression_fixe':
                      return 'À pression fixe';
                    case 'a_double_niveau_de_pression':
                      return 'À double niveau de pression';
                    case 'autopilotee':
                      return 'Autopilotée';
                    default:
                      return 'Ø';
                  }
                })(), //this.informationsForm.typeAppareil ?? 'Ø',
                pression: this.informationsForm.pression?.toString() ?? 'Ø',
                reglage: this.informationsComplementaires.reglage ?? 'Ø',
                typeInterface: this.informationsForm.typeInterface ?? 'Ø',
                marqueModele: this.informationsForm.marqueModele ?? 'Ø',
                joindreSignature: true,
                signature: {
                  fileName: 'signature.png',
                  mimeType: 'image/png',
                  content: medecin.signature.startsWith(
                    'data:image/png;base64,',
                  )
                    ? medecin.signature.replace('data:image/png;base64,', '')
                    : medecin.signature,
                },
              },
            },
          }
        : {
            formType: environment.ordoclic.renew_dap,
            autoSubmission: true,
            inputs: {
              user_id: medecin.id,
              qualification: {
                ...(medecin.qualification?.slug == 'desFstSommeil'
                  ? { desFstSommeil: true }
                  : {}),
                ...(medecin.qualification?.slug == 'parcoursSommeilAtteste'
                  ? { parcoursSommeilAtteste: true }
                  : {}),
                ...(medecin.qualification?.slug == 'diplomePathoSommeil'
                  ? { diplomePathoSommeil: true }
                  : {}),
              },
              patient: {
                nir: this.nir.slice(0, -2),
                cle_nir: this.nir.slice(-2),
                fullname: `${this.prenom
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .toUpperCase()} ${this.nom
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .toUpperCase()}`,
              },
              dap: {
                ...(this.informationsComplementaires.ppcTypeSlug == 'dap_4mois'
                  ? { renouvellement4Mois: true }
                  : {}),
                ...(this.informationsComplementaires.ppcTypeSlug == 'dap_annuel'
                  ? { renouvellementAnnuel: true }
                  : {}),
                iah:
                  parseFloat(
                    this.informationsForm.iah.toString().replace(',', '.'),
                  ) || 0,
                ...(this.informationsForm.ameliorationSymptomatologie
                  ? { ameliorationSymptomatologieOui: true }
                  : { ameliorationSymptomatologieNon: true }),
                ...(this.informationsForm.patientObservant
                  ? { patientObservantOui: true }
                  : { patientObservantNon: true }),
                commentaire: this.informationsForm.commentaire,
              },
              prescription: {
                ...(this.informationsForm.ald
                  ? { aldOui: true }
                  : { aldNon: true }),
                typeAppareil: (() => {
                  switch (this.informationsForm.typeAppareil) {
                    case 'a_pression_fixe':
                      return 'À pression fixe';
                    case 'a_double_niveau_de_pression':
                      return 'À double niveau de pression';
                    case 'autopilotee':
                      return 'Autopilotée';
                    default:
                      return 'Ø';
                  }
                })(),
                pression: this.informationsForm.pression?.toString() ?? '0',
                typeInterface: this.informationsForm.typeInterface ?? '',
                marqueModele: this.informationsForm.marqueModele ?? '',
                joindreSignature: true,
                signature: {
                  fileName: 'signature.png',
                  mimeType: 'image/png',
                  content: this.removePngBase64Prefix(medecin?.signature),
                },
              },
            },
          };
    } else {
      throw new Error('impossible de formater pour Amelipro');
    }
  }

  private removePngBase64Prefix(input: string | undefined): string {
    if (!input) {
      return '';
    }
    const prefix = 'data:image/png;base64,';
    return input.startsWith(prefix) ? input.replace(prefix, '') : input;
  }
}

export type PrescriptionFormOrdoclicInitial = {
  formType: string;
  autoSubmission: boolean;
  inputs: {
    user_id: number;
    qualification: {
      desFstSommeil?: boolean;
      parcoursSommeilAtteste?: boolean;
      diplomePathoSommeil?: boolean;
    };
    patient: {
      nir: string;
      cle_nir: string;
      fullname: string;
      adresse: string;
      code_postal: string;
      ville: string;
      telephone: string;
      date_naissance: string;
      nom_mutuelle: string;
      numero_mutuelle: string;
    };
    dap: {
      polysomnographie?: boolean;
      microEveils?: number;
      polygraphie?: boolean;
      iahLt15?: boolean;
      iahGt15Lt30?: boolean;
      iahGt30?: boolean;
      compteRendu?: {
        fileName: string;
        mimeType: string;
        content: string | null;
      };
      somnolenceDiurne?: boolean;
      ronflementsSeveres?: boolean;
      cephaleesMatinales?: boolean;
      fatigueDiurne?: boolean;
      nycturie?: boolean;
      sensationEtouffement?: boolean;
      somnolenceDiurneSevereRisqueAccidentel?: boolean;
      comorbiditeCardioVasculaireGrave?: boolean;
      comorbiditeRespiratoireGrave?: boolean;
      oam12DerniersMoisOui?: boolean;
      oam12DerniersMoisNon?: boolean;
      orientationVersOamCommentaire?: string;
    };
    prescription: {
      aldOui?: boolean;
      aldNon?: boolean;
      typeAppareil: string;
      pression: string;
      reglage: string;
      typeInterface: string;
      marqueModele: string;
      joindreSignature: boolean;
      signature: {
        fileName: string;
        mimeType: string;
        content: string | null;
      };
    };
  };
};

export type PrescriptionFormOrdoclicRenouvellement = {
  formType: string;
  autoSubmission: boolean;
  inputs: {
    user_id: number;
    qualification: {
      desFstSommeil?: boolean;
      parcoursSommeilAtteste?: boolean;
      diplomePathoSommeil?: boolean;
    };
    patient: {
      nir: string;
      cle_nir: string;
      fullname: string;
    };
    dap: {
      renouvellement4Mois?: boolean;
      renouvellementAnnuel?: boolean;
      iah: number;
      ameliorationSymptomatologieOui?: boolean;
      ameliorationSymptomatologieNon?: boolean;
      patientObservantOui?: boolean;
      patientObservantNon?: boolean;
      commentaire?: string;
    };
    prescription: {
      aldOui?: boolean;
      aldNon?: boolean;
      typeAppareil: string;
      pression: string;
      typeInterface: string;
      marqueModele: string;
      joindreSignature: boolean;
      signature: {
        fileName: string;
        mimeType: string;
        content: string | null;
      };
    };
  };
};

export type PrescriptionFormAPI = {
  id?: number;
  prescription_form_type_slug: string;
  type?: PrescriptionFormTypeAPI;
  medecin_id: number;
  medecin?: UserAPI;
  user_id: number;
  user?: UserAPI;
  nir: string;
  code_d_activite: string;
  date_de_prescription: string;
  nom: string;
  prenom: string;
  sexe?: 'homme' | 'femme';
  date_de_naissance?: string;
  adresse_ligne_1?: string;
  adresse_ligne_2?: string | null;
  adresse_code_postal?: string;
  adresse_ville?: string;
  telephone: string;
  a_signer: boolean;
  transmise: boolean;
  pdf?: string | null;
  created_at?: string;
  prescription_number?: number;
  ppc_informations_complementaires?: PpcInformationsComplementairesAPI;
  dep_informations_complementaires?: DepInformationsComplementairesAPI;
  ppc_dap_informations_form?: PpcDapInformationsFormAPI;
  ppc_ordonnance_informations_form?: PpcOrdonnanceInformationsFormAPI;
  dep_informations_form?: DepInformationsFormAPI;
  avf_ordonnance_informations_form?: AvfOrdonnanceInformationsFormAPI;
  aerosol_ordonnance_informations_form?: AerosolOrdonnanceInformationsFormAPI;
};

export class PrescriptionFormList {
  currentPage: number;
  lastPage: number;
  list: PrescriptionForm[];
  total: number;

  constructor(
    currentPage: number,
    lastPage: number,
    list: PrescriptionForm[],
    total: number,
  ) {
    this.currentPage = currentPage;
    this.lastPage = lastPage;
    this.list = list;
    this.total = total;
  }

  static factory(dapListAPI: PrescriptionFormListAPI): PrescriptionFormList {
    return new PrescriptionFormList(
      dapListAPI.current_page,
      dapListAPI.last_page,
      dapListAPI.data.map((depAPI: PrescriptionFormAPI) =>
        PrescriptionForm.factory(depAPI),
      ),
      dapListAPI.total,
    );
  }
}

export type PrescriptionFormListAPI = {
  data: PrescriptionFormAPI[];
  total: number;
  current_page: number;
  last_page: number;
  per_page?: number;
  from?: number;
  to?: number;
};
